import UserAccount from './UserAccount';
import './UserAccount.scss';

export default UserAccount;
